/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateLineParams,
  ExpenseLineDto,
  LineRequest,
  MileageLineDto,
  PerDiemLineDto,
  UpdateLineParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiReimbursementLineController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-reimbursement-line-controller
   * @name UpdateLine
   * @request PUT:/api/v1/reimbursement/{reimbursementId}/line
   */
  updateLine = (
    { reimbursementId, ...query }: UpdateLineParams,
    data: LineRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseLineDto | MileageLineDto | PerDiemLineDto, any>({
      path: `/v1/reimbursement/${reimbursementId}/line`,
      method: 'PUT',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static updateLinePath = '/v1/reimbursement/${reimbursementId}/line'
  static updateLineMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-reimbursement-line-controller
   * @name CreateLine
   * @request POST:/api/v1/reimbursement/{reimbursementId}/line
   */
  createLine = (
    { reimbursementId, ...query }: CreateLineParams,
    data: LineRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseLineDto | MileageLineDto | PerDiemLineDto, any>({
      path: `/v1/reimbursement/${reimbursementId}/line`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createLinePath = '/v1/reimbursement/${reimbursementId}/line'
  static createLineMethod = 'POST'
}
